import {
  ConeGeometry,
  CylinderGeometry,
  Group,
  Mesh,
  MeshStandardMaterial,
  SphereGeometry
} from 'three';

/** Soraka mesh — staff + star orb (OCP registry). */
export function createSorakaMesh(team = 'blue') {
  const group = new Group();
  const trim = team === 'blue' ? 0xf9a8d4 : 0xfde68a;
  const robeMat = new MeshStandardMaterial({ color: 0x4c1d95, roughness: 0.55 });
  const trimMat = new MeshStandardMaterial({ color: trim, roughness: 0.4 });
  const staffMat = new MeshStandardMaterial({ color: 0xe9d5ff, metalness: 0.5, roughness: 0.35 });

  const body = new Mesh(new ConeGeometry(0.7, 2.4, 10), robeMat);
  body.position.y = 1.4;
  group.add(body);

  const head = new Mesh(new SphereGeometry(0.38, 12, 12), trimMat);
  head.position.y = 2.75;
  group.add(head);

  const staff = new Mesh(new CylinderGeometry(0.05, 0.06, 2.5, 8), staffMat);
  staff.position.set(0.7, 1.85, 0.15);
  group.add(staff);

  const star = new Mesh(new SphereGeometry(0.2, 10, 10), trimMat);
  star.position.set(0.7, 3.2, 0.15);
  group.add(star);

  return group;
}
